import './cta-block.less';

// trim-below
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn-lite';

const b = block('cta-block');

const CTABlock = ({text, link}) => (
	<div className={b()}>
		<div className={b('container')}>
			<h3 className={b('title')}>{text}</h3>
			<a href="/contact-us" className={b('button')}>{link}</a>
		</div>
	</div>
);

CTABlock.propTypes = {
	text: PropTypes.string,
	link: PropTypes.string
};

export default CTABlock;


// WEBPACK FOOTER //
// ./src/components/cta-block/index.jsx